import { useQuery } from "react-query";
import { getPublicNotifySettings } from "../../../queries/notify";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";

export function useNotifySettingsPublic() {
  const networkHeaders = useNetworkHeaders();
  const query = useQuery(["publicNotifySettings"], getPublicNotifySettings(networkHeaders), {
    retry(failureCount, error: { status: number }) {
      if (error.status === 404) return false;
      return failureCount < 3;
    },
    refetchOnWindowFocus: false,
    refetchInterval: false,
  });
  const { data: publicNotifySettings, isLoading } = query;
  const isConfigured = !!publicNotifySettings;

  return { query, publicNotifySettings, isConfigured, isLoading };
}
